import styled from 'styled-components';
import { CHROME_INSET_PX } from './chrome.constants';

export const TopSlot = styled.div`
  position: absolute;
  top: ${CHROME_INSET_PX}px;
  left: 50%;
  translate: -50% 0;
  z-index: 4;
  max-width: calc(100% - ${CHROME_INSET_PX * 2}px);
  pointer-events: auto;
`;
